
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.883 2.46h-3.076v-.614A1.848 1.848 0 0012.96 0H8.039a1.848 1.848 0 00-1.846 1.846v.615H3.117a1.848 1.848 0 00-1.846 1.846c0 .817.535 1.512 1.272 1.754l1.098 13.247C3.72 20.257 4.528 21 5.48 21h10.04c.953 0 1.76-.743 1.84-1.693L18.457 6.06a1.849 1.849 0 001.271-1.753 1.848 1.848 0 00-1.845-1.846zm-10.46-.614c0-.34.277-.616.616-.616h4.922c.34 0 .615.276.615.616v.615H7.424v-.615zm8.71 17.36a.619.619 0 01-.613.564H5.48a.619.619 0 01-.613-.564L3.785 6.152h13.43l-1.082 13.053zm1.75-14.284H3.117a.616.616 0 010-1.23h14.766a.616.616 0 010 1.23z"}}),_c('path',{attrs:{"d":"M8.038 17.886L7.423 7.96a.616.616 0 00-1.228.076l.615 9.926a.615.615 0 101.228-.076zM10.5 7.383a.615.615 0 00-.615.615v9.926a.615.615 0 101.23 0V7.998a.615.615 0 00-.615-.615zM14.23 7.384a.616.616 0 00-.653.576l-.615 9.926a.615.615 0 001.228.076l.616-9.926a.615.615 0 00-.576-.652z"}})])
          )
        }
      }
    